import { render, staticRenderFns } from "./CustomerEditData.vue?vue&type=template&id=7b0a4e72&scoped=true"
import script from "./CustomerEditData.vue?vue&type=script&lang=js"
export * from "./CustomerEditData.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditData.vue?vue&type=style&index=0&id=7b0a4e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0a4e72",
  null
  
)

export default component.exports